module.exports = __webpack_public_path__ + "img/foto-catiane.7af25a58.png";